export default __webpack_public_path__ + "assets/3eb2917a3a6183c368d838954ce0c2b1.png";